// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.chat-modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 12px;
    width: 400px;
    max-height: 80%;
    display: flex;
    flex-direction: column;
    position: relative;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
}

.chat-history {
    flex-grow: 1;
    min-height: 500px; /* Изначальная высота длинного контента */
    max-height: 700px; /* Ограничение максимальной высоты */
    overflow-y: auto; /* Прокрутка, если контент превышает максимальную высоту */
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    background-color: #f3f4f6;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.chat-message {
    max-width: 70%;
    padding: 10px 15px;
    border-radius: 15px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
}

.chat-message p {
    margin: 0;
}

.chat-message small {
    display: block;
    margin-top: 5px;
    font-size: 11px;
    color: #555;
}

.chat-message.user {
    align-self: flex-end;
    background-color: #007bff;
    color: white;
}

.chat-message.officer {
    align-self: flex-start;
    background-color: #f1f1f1;
    color: #333;
}

.chat-input {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}

.chat-input input {
    flex: 1 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 25px;
}

.chat-input button {
    padding: 10px 20px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    font-size: 14px;
}

.chat-input button:hover {
    background-color: #0056b3;
}

.status-indicator {
    display: inline-block;
    margin-left: 10px;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 14px;
    color: white;
}

.status-indicator.connected {
    background-color: green;
}

.status-indicator.disconnected {
    background-color: red;
}

.status-indicator.error {
    background-color: orange;
}
`, "",{"version":3,"sources":["webpack://./src/style/ChatModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB,EAAE,yCAAyC;IAC5D,iBAAiB,EAAE,oCAAoC;IACvD,gBAAgB,EAAE,0DAA0D;IAC5E,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".chat-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.chat-modal-content {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 12px;\n    width: 400px;\n    max-height: 80%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 18px;\n    cursor: pointer;\n}\n\n.chat-history {\n    flex-grow: 1;\n    min-height: 500px; /* Изначальная высота длинного контента */\n    max-height: 700px; /* Ограничение максимальной высоты */\n    overflow-y: auto; /* Прокрутка, если контент превышает максимальную высоту */\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 10px;\n    background-color: #f3f4f6;\n    margin-bottom: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.chat-message {\n    max-width: 70%;\n    padding: 10px 15px;\n    border-radius: 15px;\n    font-size: 14px;\n    line-height: 1.5;\n    word-wrap: break-word;\n}\n\n.chat-message p {\n    margin: 0;\n}\n\n.chat-message small {\n    display: block;\n    margin-top: 5px;\n    font-size: 11px;\n    color: #555;\n}\n\n.chat-message.user {\n    align-self: flex-end;\n    background-color: #007bff;\n    color: white;\n}\n\n.chat-message.officer {\n    align-self: flex-start;\n    background-color: #f1f1f1;\n    color: #333;\n}\n\n.chat-input {\n    display: flex;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.chat-input input {\n    flex: 1;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 25px;\n}\n\n.chat-input button {\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 25px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.chat-input button:hover {\n    background-color: #0056b3;\n}\n\n.status-indicator {\n    display: inline-block;\n    margin-left: 10px;\n    padding: 5px 10px;\n    border-radius: 5px;\n    font-size: 14px;\n    color: white;\n}\n\n.status-indicator.connected {\n    background-color: green;\n}\n\n.status-indicator.disconnected {\n    background-color: red;\n}\n\n.status-indicator.error {\n    background-color: orange;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
